import {
  FilterTreeNode,
  ResourceExplorerDynamicFilterItemType,
  ResourceType,
} from "@/services/cloudchipr.api";

export const generateResourceDetailsK8SResourceBillingDataPayload = (
  identifier: string[],
  resourceType: ResourceType,
): FilterTreeNode => ({
  node_type: "group",
  operator: "and",
  items: [
    {
      operator: "in",
      node_type: "item",
      value: identifier,
      filter_provider: "kubernetes",
      type: getFilterTypeFromResourceType(resourceType),
    },
  ],
});

const getFilterTypeFromResourceType = (resourceType: ResourceType) => {
  return resourceType.replace(
    "kubernetes_",
    "",
  ) as ResourceExplorerDynamicFilterItemType;
};
